import React, { useState } from 'react';
import Toast from '../components/molecules/Toast';
import { ToastOptions } from '../utils/types/ui';

const ToastContext = React.createContext<{
    showToast: (message: string, options?: ToastOptions) => void;
}>({
    showToast: () => {},
});

export const useToast = () => React.useContext(ToastContext);

interface ToastProviderProps {
    children: React.ReactNode;
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
    const [toastMessage, setToastMessage] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [toastOptions, setToastOptions] = useState<ToastOptions>({});

    const showToastMessage = (
        message: string,
        options?: ToastOptions
    ) => {
        setToastMessage(message);
        setToastOptions({ ...toastOptions, ...options });
        setShowToast(true);
    };

    const hideToast = () => {
        setShowToast(false);
        setToastMessage('');
        setToastOptions({});
    };

    return (
        <ToastContext.Provider value={{ showToast: showToastMessage }}>
            {children}
            {showToast && (
                <Toast
                    message={toastMessage}
                    onClose={hideToast}
                    {...toastOptions}
                />
            )}
        </ToastContext.Provider>
    );
};
